import injectSheet from "react-jss";
import styles from "./checklistsection_styles"
import {Section} from "@insticator/insticator-ui";

const ChecklistSection = injectSheet(styles)((props) => {
    const {title, checkListBody , selectedBody,className, titlelink, isContentPresent} = props;
    return (
        <div className={`checklistsection ${props.classes.checklistSection}`}>
                <div className={`listSection ${props.classes.listSection}`}>
                    <div className={`titlesection ${props.classes.titleSection}`}>
                        <h3 className={`title ${props.classes.title}`}>{title}</h3>
                    </div>
                    <Section row className={`${className}`}>
                        {checkListBody}
                    </Section>
                </div>
            <div className={`selectedSection ${props.classes.SelectedSection}`}>
                <div className={`titlesection ${props.classes.titleSection}`}>
                    <h3 className={`title ${props.classes.title}`}>Selected</h3>
                    {isContentPresent && titlelink}
                </div>
                <Section row>
                    {selectedBody}
                </Section>
            </div>
        </div>

    )
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ChecklistSection;
